function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  rx: 1,
  fill: "#EF6969"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.5186 20.6705C47.1133 20.0757 47.1133 19.1113 46.5186 18.5166C45.9238 17.9218 44.9594 17.9218 44.3647 18.5166L31.9997 30.8815L19.636 18.5178C19.0413 17.923 18.0769 17.923 17.4821 18.5178C16.8874 19.1126 16.8874 20.0769 17.4821 20.6717L29.8458 33.0354L18.5179 44.3634C17.9231 44.9581 17.9231 45.9225 18.5179 46.5173C19.1126 47.112 20.077 47.112 20.6718 46.5173L31.9997 35.1893L43.3289 46.5185C43.9237 47.1133 44.8881 47.1133 45.4828 46.5185C46.0776 45.9237 46.0776 44.9594 45.4828 44.3646L34.1536 33.0354L46.5186 20.6705Z",
  fill: "white"
});

var SvgToolbarDelete = function SvgToolbarDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgToolbarDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ToolbarDelete.fe694d23.svg";
export { ForwardRef as ReactComponent };